import React from "react";

const PlanTableCellHour = ({ existingTime, timeIndex, setTime, isMerged, toggleMerged, lunchRecs, toggleLunchRecs }) => {
    const timechange = (value) => {
        setTime(value, timeIndex)
    }

    return (
        <td scope="row" className="font-medium text-sm">
            <textarea className=" w-full min-w-[110px] max-w-[110px] py-3 px-2 xl:px-4 bg-transparent w-full font-semibold text-medium placeholder:text-xs resize-none" rows={2} placeholder="Naziv obroka&#10;+ vreme" value={existingTime || ''} onChange={(e) => timechange(e.target.value, timeIndex)} />
            <label className="flex items-center px-2 xl:px-4 pb-2 text-[10px] text-gray-500 cursor-pointer select-none whitespace-nowrap">
                <input
                    type="checkbox"
                    className="mr-1 accent-blueSecondary cursor-pointer"
                    checked={!!isMerged}
                    onChange={() => toggleMerged(timeIndex)}
                />
                Spoji dane
            </label>
            {isMerged ? (
                <label className="flex items-center px-2 xl:px-4 pb-2 text-[10px] text-gray-500 cursor-pointer select-none whitespace-nowrap">
                    <input
                        type="checkbox"
                        className="mr-1 accent-blueSecondary cursor-pointer"
                        checked={!!lunchRecs}
                        onChange={() => toggleLunchRecs(timeIndex)}
                    />
                    Dodaj preporuke za ru&#269;ak
                </label>
            ) : null}
        </td>
    );
};

export default PlanTableCellHour;
